
<script>
import load from '@/components/base/load';
import MallMethod from './mall.js';
import UiBase from './uibase.js';
export default {
    mixins: [load,MallMethod,UiBase],
    data() {
        return {
            globalConfig:{
                dictkey:[],
                dictData:{},
                userModuleMethod:[],
                modulecode:'',
                billmain:{},
                dictgroupkey:[]
            }, 
            uiconfig:{},
            billImportConfig:{
                typeData:[]
            }
        };
    },
    props:{
        billmoduleid:{
            type:String,
            default:''
        }
    },
    methods:{
        setDictKey (dictkey) {
            if (dictkey) {
                this.globalConfig.dictkey = dictkey.split(',');
            }
        },
        // check重复
        checkDuplicate (obj) {
            let self = this;
            let method = this.uiconfig.classPrefix + '.search';
            let flag = false;
            self.synchroPost(this.uiconfig.resources, method, obj, function (data) {
                if (data[self.uiconfig.response] && data[self.uiconfig.response].length > 0) {
                    flag = true;
                }
            });
            return flag;
        },
      
        init() {
            // 处理模块号提示
            this.globalConfig.modulecode = this.$Method.getUrlParam('modulecode');
            if (!this.globalConfig.modulecode) {
                this.globalConfig.modulecode = this.$Method.getUrlParam('billmoduleid');
            }
            if (this.billmoduleid) {
                this.globalConfig.modulecode = this.billmoduleid;
            }
            /* 审批流改从uiconfig表取
            this.globalConfig.billmain = this.getBillMain(this.globalConfig.modulecode);
            if (this.globalConfig.billmain) {
                this.billisworkflow = this.globalConfig.billmain.billisworkflow;
            }*/
            if (this.getCustomUiCongfig) {
                this.uiconfig = this.getCustomUiCongfig(this.globalConfig.modulecode);
            } else {
                this.uiconfig = this.getUiCongfig(this.globalConfig.modulecode);
            }
            if (this.selectkey.length > 0) {
                let temp = this.getFairyConfig(this.selectkey);
                this.setQueryConfig(temp);
            }
            this.globalConfig.dictkey = this.$Method.copy(this.dictkey);
            this.setDictData();
            this.setUserModuleMethod();
        },
      
       
        getDictData(obj) {
            let temp = [];
            for (let pro in obj) {
                if (this.globalConfig.dictData[pro]) {
                    obj[pro] = this.$Method.copy(this.globalConfig.dictData[pro]);
                } else {
                    temp.push(pro);
                }
            }
            if (temp.length > 0) {
                Object.assign(obj, this.getDict(temp.join(','), 'code,name,pro1,ddvalue'));
                Object.assign(this.globalConfig.dictData, obj);
            }
            return obj;
        },
        setDictData() {
             // 调用字典方法
            if (this.globalConfig.dictkey.length > 0) {
                const dictkey = this.globalConfig.dictkey.join(',');
                this.globalConfig.dictData = this.getDict(dictkey,'code,name,pro1,ddvalue');
            }
            // 自定义添加
            if (this.initUserDict) {
                Object.assign(this.globalConfig.dictData, this.initUserDict());
            }
        },
        setUserModuleMethod() {
            let data = this.getUserModuleMethod(this.globalConfig.modulecode);
            if (data && data.modulemethod) {
                this.globalConfig.userModuleMethod = this.$Method.copy(data.modulemethod);
            }
        },
        doAction (action) {
            const method = action.name;
            const  methodBefore = method + 'Before';
            let flag = true;
            if (this[methodBefore]) {
                flag = this[methodBefore](action);
            }
            if (flag) {
                if (this[method]) {
                    this[method](action);
                } else {
                    this.doPost(action);
                }
            }
        },
        getActionMethod(action) {
            let name = action.name;
            const type = action.name;
            if (type === 'addData') {
                name = 'save';
            }
            if (type === 'saveData') {
                name = 'save';
            }
            if (type === 'delData') {
                name = 'save';
            }
            if (type === 'auditData') {
                name = 'billaudit';
            }
            if (type === 'cancelData') {
                name = 'billcancel';
            }
            if (type === 'voidData') {
                name = 'billvoid';
            }
            if (type === 'importExcel') {
                name = 'importExcel';
            }
            if (type === 'copyData') {
                name = 'copy';
            }
            if (type === 'submitData') {
                name = 'billsubmit';
            }
            if (type === 'revokeData') {
                name = 'billrepeal';
            }
            if (this.getCustomActionMethod) {
                const temp = this.getCustomActionMethod(type, name);
                if(temp) {
                    name = temp;
                }
            }
            return name;
        },
        doPost(action) {
            let flag = true;
            let self = this;
            this.loadingtext = self.getActionName(action);
            const methodAfter = action.name + 'After';
            let method = this.uiconfig.classPrefix + '.' + this.getActionMethod(action);
            this.showLoading();
            let postData = action.para;
            if (this.setChangeData) {
                postData = this.setChangeData(action);
            }
            self.asyncPost(this.uiconfig.resources, method, postData, function(data){
                let msg = self.loadingtext +'成功!';
                if (data.msg) {
                    msg = data.msg;
                }
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(msg,null,3);
                    }, 250);
                });

                if (self.$refs.layout.setPhkey) {
                    if (data instanceof Array) {
                        if (data.length > 0) {
                            self.$refs.layout.setPhkey(data[0].ph_key);
                        }
                    } else {
                        if (data.ph_key) {
                            self.$refs.layout.setPhkey(data.ph_key);
                        }
                    }
                   
                }
               
                if (self[methodAfter]) {
                    self[methodAfter](data);
                }
                if (action.onOk) {
                    action.onOk(action, data);
                }
            },function(data) {
                const msg = self.loadingtext +'失败!' + data;
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(msg,null,2);
                    }, 250);
                });
                flag = false;
            },function(data) {
                const msg = self.loadingtext +'异常!' + data;
                self.hideLoading();
                self.$nextTick(() =>{
                    setTimeout(() => {
                        self.alert(msg,null,2);
                    }, 250);
                });
                flag = false;
            });
            return flag;
        },
        getActionName(action) {
            let btnConfig = this.globalConfig.userModuleMethod.find(el => el.name === action.name);
            let text = '';
            if (btnConfig && btnConfig.text) {
                text = btnConfig.text;
            }
            if (this.getCustomActionName) {
                const temp = this.getCustomActionName(action.name, text);
                if(temp) {
                    text = temp;
                }
            }
            return text;
        },
        // 下载导入模版
        downTemplate() {
            const url = this.uiconfig.resources;
            let param = this.getDownTemplateParam();
            this.$refs.billImport.setDownUrl(url,param);
        },
        getDownTemplateParam () {
            if (this.customGetDownTemplateParam) {
                return this.customGetDownTemplateParam();
            } else {
                let obj = {};
                obj.billmoduleid = this.globalConfig.modulecode;
                return obj;
            }
        },
        // 导入
        importExcel() {
            const url =this.uiconfig.resources;
            const classPrefix =   this.uiconfig.classPrefix ;
            let para = this.getImportParam();
            this.$refs.billImport.setUrl(url,classPrefix,para);
            this.$refs.billImport.setShowUpload(true);
        },
        getImportParam () {
            if (this.customGetImportParam) {
                return this.customGetImportParam();
            } else {
                let data = this.getForm().getData();
                let obj = {};
                obj.ph_key =data.ph_key;
                obj.billmoduleid = this.globalConfig.modulecode;
                return obj;
            }
        },
        getForm(name){
            return this.$refs.layout.getForm().getForm(name);
        },
        getDetail(name){
            return this.$refs.layout.getForm().getDetail(name);
        },
        getDetailTitle(name){
            return this.$refs.layout.getForm().getDetailTitle(name);
        },
        getTree () {
            if (this.$refs.layout.getTree) {
                return this.$refs.layout.getTree();
            } else {
                return null;
            }
        },
        getMenuToolbar() {
            return this.$refs.layout.getMenuToolbar();
        },
        getGrid () {
            if (this.$refs.layout.getGrid) {
                return this.$refs.layout.getGrid();
            } else {
                return null;
            }
        }
        
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/base.vue